import { render, staticRenderFns } from "./FifthSection.vue?vue&type=template&id=c6197b56&"
import script from "./FifthSection.vue?vue&type=script&lang=ts&"
export * from "./FifthSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports